import styled from "../../styled";
import { themeLss } from "../../lss";
export var TextInputIcon = styled.span(themeLss(function (_ref) {
  var position = _ref.position,
      isIconBgTransparent = _ref.isIconBgTransparent;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    height: '100%',
    minHeight: '38px',
    border: 'none',
    outline: 'none',
    fontSize: 'content',
    color: !isIconBgTransparent ? 'text' : 'textLight',
    px: 'md',
    bg: isIconBgTransparent ? 'inherit' : 'disabled',
    borderRight: !isIconBgTransparent && position === 'left' ? 'regular' : 'none',
    borderLeft: !isIconBgTransparent && position === 'right' ? 'regular' : 'none',
    borderColor: 'border',
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    '::selection': {
      background: 'transparent'
    }
  };
}));